import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu} from '../../../hooks/useMenu';
import ResetComplete from '../totalizers/reset-complete';
import CommandsContext from '../../../context/commandsContext';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function ResetAll({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<ResetComplete />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <BodyContentView
      title={t('resetAll.title')}
      left={t('resetAll.a2')}
      right={t('resetAll.a3')}
      caption={t('resetAll.a1')}
    />
  );
}

export default ResetAll;
